import { combineReducers } from "@reduxjs/toolkit";
import userReducer from "./user";
import systemReducer from "./system";
import diagramReducer from "./diagram";

export default combineReducers({
  user: userReducer,
  system: systemReducer,
  diagram: diagramReducer,
});
